import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import Hero from './components/Hero';
import ServicesGrid from './components/ServicesGrid';
import HomeTestimonials from './components/HomeTestimonials';
import { Link } from 'react-router-dom';

export default function Home() {
  return (
    <div className="min-h-screen bg-brand-black font-body">
      <Navbar />
      <main>
        <Hero />

        {/* Intro Band */}
        <section className="w-full bg-brand-green py-10 px-6 lg:px-12">
          <div className="w-full max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6">
            <p className="font-heading font-700 text-white text-2xl md:text-3xl tracking-widest uppercase text-center md:text-left">
              ONE COMPANY. ONE CALL. COMPLETE LAND SERVICES
            </p>
            <Link
              to="/contact"
              className="shrink-0 px-8 py-3 bg-white hover:bg-gray-100 font-heading font-700 text-brand-green text-base tracking-widest uppercase cursor-pointer whitespace-nowrap transition-colors rounded-sm"
            >
              Start Your Project
            </Link>
          </div>
        </section>

        <ServicesGrid />

        {/* Why Choose Us */}
        <section className="w-full bg-brand-black py-24 px-6 lg:px-12">
          <div className="w-full max-w-7xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
              <div>
                <p className="font-heading text-brand-green-accent text-xs tracking-[0.4em] uppercase mb-3">Why Holston</p>
                <h2 className="font-heading font-800 text-white text-5xl md:text-6xl tracking-widest uppercase leading-tight mb-6">
                  Experienced.<br />Professional.<br />Straightforward.
                </h2>
                <div className="w-12 h-0.5 bg-brand-green-accent mb-8" />
                <p className="font-body text-gray-400 text-base leading-relaxed mb-8">
                  Holston Land Management's years of hands-on experience are behind every service we offer. Communication with our clients is important to us as we believe the process should be as straightforward as the work itself.
                </p>
                <ul className="flex flex-col gap-4">
                  {[
                    'Reliability and consistency',
                    'Clear communication from quote to completion',
                    'Projects of all sizes',
                    'Serving homeowners, builders, and contractors',
                  ].map((item) => (
                    <li key={item} className="flex items-start gap-3">
                      <div className="w-5 h-5 flex items-center justify-center shrink-0 mt-0.5">
                        <i className="ri-checkbox-circle-fill text-brand-green-accent" />
                      </div>
                      <span className="font-body text-sm text-gray-300">{item}</span>
                    </li>
                  ))}
                </ul>
                <div className="mt-10">
                  <Link
                    to="/about"
                    className="inline-block px-8 py-3 border border-brand-green-accent text-brand-green-accent hover:bg-brand-green-accent hover:text-brand-black font-heading font-700 text-sm tracking-widest uppercase cursor-pointer whitespace-nowrap transition-colors rounded-sm"
                  >
                    About Us
                  </Link>
                </div>
              </div>
              <div className="relative h-96 lg:h-[500px]">
                <img
                  src="https://storage.readdy-site.link/project_files/a87775cd-cdf2-4bef-9fc3-2b80005013bf/399bc5af-a71d-4389-bc93-9dea96fdd97f_hill-road.png?v=f2a7ae9759334429d672e37b6a30effb"
                  alt="Professional land clearing crew in Tennessee"
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-brand-black/60 to-transparent h-1/3" />
                <div className="absolute bottom-6 left-6 bg-brand-green px-5 py-3">
                  <p className="font-heading font-700 text-white text-sm tracking-widest uppercase">Based in Northeast TN</p>
                  <p className="font-body text-xs text-green-200 mt-1">Serving Customers Nationwide</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <HomeTestimonials />

        {/* Final CTA */}
        <section className="w-full bg-brand-charcoal py-24 px-6 lg:px-12">
          <div className="w-full max-w-7xl mx-auto text-center">
            <p className="font-heading text-brand-green-accent text-xs tracking-[0.4em] uppercase mb-3">Ready to Start?</p>
            <h2 className="font-heading font-800 text-white text-5xl md:text-6xl tracking-widest uppercase mb-4">
              Let's Get to Work
            </h2>
            <div className="w-12 h-0.5 bg-brand-green-accent mx-auto mb-8" />
            <p className="font-body text-gray-400 text-base max-w-xl mx-auto mb-10">
              Contact us to discuss your project. Based in Northeast TN, serving customers nationwide.
            </p>
            <Link
              to="/contact"
              className="inline-block px-12 py-4 bg-brand-green hover:bg-brand-green-mid font-heading font-700 text-white text-xl tracking-widest uppercase cursor-pointer whitespace-nowrap transition-colors rounded-sm"
            >
              Get a Free Quote
            </Link>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
